module.exports = __webpack_public_path__ + "img/house_overview.662e73c6.jpg";